module.exports = __webpack_public_path__ + "img/panellogin__header__bg.f5a2cd0.jpg";